export const toggleMobileNav = () => ({
  type: 'TOGGLE_MOBILE_NAV',
});
